export const displayValue = (value) => {
	if (value === null || value === undefined || value === "") return "-";
	return String(value);
};

export const formatPerson = (person) => {
	if (!person || typeof person !== "object") return "-";
	const fullName = `${person.firstName || ""} ${person.lastName || ""}`.trim();
	return fullName || "-";
};

export const getInitials = (firstName, lastName) => {
	const first = String(firstName || "").trim();
	const last = String(lastName || "").trim();
	const firstChar = first ? first[0].toUpperCase() : "";
	const lastChar = last ? last[0].toUpperCase() : "";
	const initials = `${firstChar}${lastChar}`.trim();
	return initials || "-";
};

export const prettifyEnum = (value) => {
	const raw = String(value || "").trim();
	if (!raw) return "";
	return raw
		.replace(/[-_]+/g, " ")
		.split(" ")
		.filter(Boolean)
		.map((part) => part.charAt(0).toUpperCase() + part.slice(1))
		.join(" ");
};

export const getAppointmentStatusColor = (status, darkMode) => {
	const statusLower = String(status || "").toLowerCase();
	if (statusLower.includes("schedule") || statusLower.includes("pending")) {
		return darkMode
			? "bg-blue-500/10 text-blue-400 border-blue-500/20"
			: "bg-blue-100 text-blue-800 border-blue-200";
	}
	if (statusLower.includes("confirm")) {
		return darkMode
			? "bg-amber-500/10 text-amber-400 border-amber-500/20"
			: "bg-amber-100 text-amber-800 border-amber-200";
	}
	if (statusLower.includes("complete")) {
		return darkMode
			? "bg-emerald-500/10 text-emerald-400 border-emerald-500/20"
			: "bg-emerald-100 text-emerald-800 border-emerald-200";
	}
	if (statusLower.includes("cancel")) {
		return darkMode
			? "bg-rose-500/10 text-rose-400 border-rose-500/20"
			: "bg-rose-100 text-rose-800 border-rose-200";
	}
	return darkMode
		? "bg-gray-500/10 text-gray-400 border-gray-500/20"
		: "bg-gray-100 text-gray-800 border-gray-200";
};
